import { apiSlice } from "../../app/api/apiSlice"

export const transactionsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getTransactionsFiltered: builder.query({
            query: ({ page, limit, filters = {} }) => {
                // Convert arrays to comma-separated strings and filter out empty values
                const processedFilters = {};
                
                Object.keys(filters).forEach(key => {
                    const value = filters[key];
                    
                    // Skip null, undefined, empty strings, and empty arrays
                    if (value === null || value === undefined || value === '') {
                        return;
                    }
                    
                    if (Array.isArray(value)) {
                        // Only add if array has items
                        if (value.length > 0) {
                            processedFilters[key] = value.join(',');
                        }
                    } else {
                        processedFilters[key] = value;
                    }
                });
                
                console.log('API Query Params:', { ...processedFilters, page, limit });
                
                return {
                    url: "/transactions/filtered",
                    params: { ...processedFilters, page, limit },
                    validateStatus: (response) => response.status === 200,
                };
            },
            transformResponse: (responseData) => {
                const transformedData = {
                    transactions: responseData.transactions?.map((transaction) => ({
                        ...transaction,
                        id: transaction._id,
                    })) || [],
                    totalFilteredTransactions: responseData.totalFilteredTransactions || 0,
                    totalPages: responseData.totalPages || 1,
                };
                return transformedData;
            },
            providesTags: (result) =>
                result?.transactions
                    ? [
                        { type: "TRANSACTIONS", id: "LIST" },
                        ...result.transactions.map((transaction) => ({
                            type: "TRANSACTIONS",
                            id: transaction.id,
                        })),
                    ]
                    : [{ type: "TRANSACTIONS", id: "LIST" }],
        }),
        addNewTransaction: builder.mutation({
            query: initialTransactionData => ({
                url: '/transactions',
                method: 'POST',
                body: {
                    ...initialTransactionData,
                }
            }),
            invalidatesTags: [
                { type: 'TRANSACTIONS', id: "LIST" }
            ]
        }),       
        updateTransaction: builder.mutation({
            query: initialTransactionData => ({
                url: '/transactions',
                method: 'PUT',
                body: {
                    ...initialTransactionData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'TRANSACTIONS', id: arg.id }
            ]
        }),       
        deleteTransaction: builder.mutation({
            query: ({ id }) => ({
                url: `/transactions`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'TRANSACTIONS', id: arg.id }
            ]
        }),       
    }),
})

export const { 
    useGetTransactionsFilteredQuery,
    useLazyGetTransactionsFilteredQuery,
    useAddNewTransactionMutation,
    useUpdateTransactionMutation,
    useDeleteTransactionMutation 
} = transactionsApiSlice